export default __webpack_public_path__ + "static/media/page-drinks.524655d6.jpg";